import { create } from 'zustand';

export type Role = 'admin' | 'auditor' | 'executive' | 'dataEntry' | 'viewer' | 'investor';

type User = { email: string; domain: string; role: Role } | null;

const PERMISSIONS: Record<string, Role[]> = {
  simulation: ['admin', 'executive', 'dataEntry'],
  audit: ['auditor'],
  marketplace: ['investor', 'executive'],
  settings: ['admin']
};

type AuthState = {
  user: User;
  setUser: (u: User) => void;
  has: (permission: keyof typeof PERMISSIONS) => boolean;
};

const STORAGE_KEY = 'evat_auth_user';

export const useAuthStore = create<AuthState>((set, get) => {
  let initial: User = null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY); if (raw) initial = JSON.parse(raw);
  } catch {}
  return {
    user: initial,
    setUser: (u) => { set({ user: u }); try { localStorage.setItem(STORAGE_KEY, JSON.stringify(u)); } catch {} },
    has: (perm) => {
      const u = get().user; if (!u) return false;
      return PERMISSIONS[perm]?.includes(u.role) ?? false;
    }
  };
});



















